module.exports = __webpack_public_path__ + "static/media/infor.1e2d15ab.svg";